import { render, staticRenderFns } from "./AlbumForm.vue?vue&type=template&id=c040c24c"
import script from "./AlbumForm.vue?vue&type=script&lang=js"
export * from "./AlbumForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports